export default __webpack_public_path__ + "static/media/platform-1.88033a39.png";